import { CartActionType } from './actions';
import { CartStateType } from './index';
import { CartActionKind } from './actions';

function cartReducer(state: CartStateType, action: ReturnType<CartActionType>) {
  switch (action.type) {
    case CartActionKind.ADD_TO_CART:
      return [...state, action.payload.pkg];
    case CartActionKind.REMOVE_FROM_CART:
      return state.filter(pkg => pkg.id !== action.payload.pkgId);
    default:
      return state;
  }
}

export default cartReducer;
